/* eslint-disable import/prefer-default-export */

const contentType = (labelText, menuText, labelColor, slug) => ({
  labelText,
  menuText,
  labelColor,
  slug,
});

const ALL_TYPE = { all: contentType('All', 'All Resources', 'primary', null) };
export const ALL_TYPE_KEY = Object.keys(ALL_TYPE)[0];

export const CONTENTFUL_TYPES = {
  ...ALL_TYPE,
  ContentfulWebinar: contentType('Webinar', 'Webinars', 'purple', 'webinars'),
  ContentfulWhitepaper: contentType(
    'White Paper',
    'White Papers',
    'primary',
    'whitepapers'
  ),
};

export const getHumanReadableContentTypeFromContentfulType = contentfulType =>
  CONTENTFUL_TYPES[contentfulType].labelText;

export const getSlugFromContentfulType = contentfulType =>
  CONTENTFUL_TYPES[contentfulType].slug;

export const getBackgroundColorFromContentfulType = contentfulType => waffles =>
  waffles.theme.colors[CONTENTFUL_TYPES[contentfulType].labelColor];
